// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"702":"story","715":"list"}[chunkId] || chunkId) + "-" + {"583":"bdb48788517c4ffab4c9","702":"180eb516cd0b0b6cc2ab","715":"db5c62cf6210272eb2af"}[chunkId] + ".css";
};